module.exports = __webpack_public_path__ + "img/PJ.4dc70c51.png";